///ts:ref=Mob
/// <reference path="./data/game/Mob.ts"/> ///ts:ref:generated

interface IBunnyDesc {
	cutieTex: PIXI.Texture;
	jumpTex: PIXI.Texture;
	shadowTex: PIXI.Texture;
	shadowJumpTex?: PIXI.Texture;
	corpses?: Array<PIXI.Texture>;
	corpseTint?: number;
	zIndex?: number;
	corpseFrames?: number;
}

class Bunny extends Mob {
	static padY = 100;
	static disperceX = 100;

	static gravity = 0.5;
	static jumpK = 5;
	static jumpB = 5;

	static runK = 5;
	static runB = 10;

	desc: IBunnyDesc;

	cutie: PIXI.Sprite;
	shadow: PIXI.Sprite;

	skins: Array<IBunnyDesc>;
	dead: boolean = false;

	constructor(desc: IBunnyDesc, dict: MobDict) {
		super(dict);

		this.shadow = new PIXI.Sprite(desc.shadowTex);

		// this is how we set the layer - we need view for element!
		this.shadow.view = new PIXI.display.View(this.shadow);
		this.shadow.view.parentLayer = Game.shadows;
		this.shadow.anchor.set(0.5);

		this.addChild(this.shadow);

		this.cutie = new PIXI.Sprite(desc.cutieTex);
		this.cutie.view = new PIXI.display.View(this.cutie);
		this.cutie.view.parentLayer = Game.layers[desc.zIndex || 0];
		this.cutie.anchor.set(0.5);

		this.speed = this.movementSpeed;

		this.addChild(this.cutie);

		this.setDesc(desc);
	}

	init() {
		this.respawn();
		this.speed = this.movementSpeed;
		this.runTime = 0;
		this.jumping = false;
		this.dead = false;
		this.lifeNumber++;
		this.targetPos = null;
		this.targetVel = null;
	}

	setDesc(desc: IBunnyDesc) {
		this.desc = desc;
		this.checkTex();
	}

	checkTex() {
		let desc = this.desc;
		if (this.skins) {
			const len = this.skins.length;
			let num = Math.floor((this.healthMax - this.health) * len / this.healthMax);
			if (num < 0) num = 0;
			if (num >= len) num = len - 1;
			desc = this.skins[num];
		}

		if (this.jumping) {
			this.cutie.texture = desc.jumpTex;
			this.shadow.texture = desc.shadowJumpTex || desc.shadowTex;
		} else {
			this.cutie.texture = desc.cutieTex;
			this.shadow.texture = desc.shadowTex;
		}
	}


	/**
	 * The amount of gravity
	 * @type {Number}
	 */

	/**
	 * Horizontal speed
	 * @type {Number}
	 */
	speed: number;

	targetPos: PIXI.Point;
	targetVel: PIXI.Point;
	killerBullet: Bullet;
	lifeNumber: number = 0;

	readyToDie() {
		return this.zombie && (!this.killerBullet || this.killerBullet.zombie);
	}

	updateMove(delta: number, bounds: PIXI.Rectangle) {
		const pos = this.position;

		if (pos.x > App.screen.width + 50) {
			if (!this.dead) {
				this.die(false);
				if (this.cell) {
					Game.worldController.removeActor(this);
				}
			}
			return;
		}

		//30 is our testing framerate
		if (!this.targetPos) {
			//make random target?
			let minY = Math.max(this.position.y - Bunny.disperceX, Bunny.padY);
			let maxY = Math.min(this.position.y + Bunny.disperceX, App.screen.height - Bunny.padY);

			this.targetPos = new PIXI.Point(App.screen.width + 100, Math.random() * (maxY - minY) + minY);
			this.targetVel = null;
		}

		if (!this.targetVel) {
			const tv = new PIXI.Point();
			tv.set(this.targetPos.x - pos.x,
				this.targetPos.y - pos.y);
			const d = 1.0 / Math.sqrt(tv.x * tv.x + tv.y * tv.y);
			tv.x *= d;
			tv.y *= d;
			this.targetVel = tv;
		}

		const tv = this.targetVel;
		const dist = this.speed * delta;
		if (!this.cell || !this.cell.building) {
			pos.x += tv.x * dist;
		}
		pos.y += tv.y * dist;

		this.updateAnim(delta);

		if (this.readyToDie()) {
			if (!this.jumping) {
				this.die();
			} else {
				this.cutie.tint = 0xff5555;
			}
		} else if (this.zombie) {
			this.cutie.tint = 0xff5555;
		}
	}

	// randomPos() {
	// 	this.position.x = -100;
	// 	this.position.y = (Math.random() * 0.8 + 0.1) * App.screen.height;
	// 	this.targetPos = null;
	// }

	die(countKill: boolean = true) {
		const desc = this.desc;
		if (desc.corpses && desc.corpses.length > 0) {
			const corpse = new Corpse(this.desc.corpses[0], desc.corpseFrames || 0);
			corpse.position.set(Math.round(this.position.x), Math.round(this.position.y));
			corpse.scale.set(Math.random() * 0.2 + 0.9);
			corpse.rotation = (Math.random() - 0.5) * 0.4;
			corpse.anchor.set(0.5);
			corpse.tint = desc.corpseTint || 0xffffff;

			if (desc.corpseFrames) {
				Game.corpsesContainer.addChild(corpse);
			} else {
				Background.stage.addChild(corpse);
			}
		}
		if (this.boomRadius > 0) {
			Game.makeBoom(this.x, this.y, this);
		}
		// this.respawn();
		this.killerBullet = null;
		// this.randomPos();
		this.cutie.tint = 0xffffff;
		this.dead = true;
		this.emit('dead', this);

		if (countKill) {
			Game.statBar.enemyKilled(this);
		}
	}

	//jumping and running animation

	runTime = 0.0;
	jumpVel = 0.0;
	jumping: boolean = false;

	updateAnim(delta: number) {
		if (this.skins) {
			this.checkTex();
		}

		//jumping state
		if (this.jumping) {

			const cutiePos = this.cutie.position;

			this.jumpVel += Bunny.gravity;

			cutiePos.y += this.jumpVel;

			if (this.zombie && this.targetVel.x > 0 && this.name === DictNames.rabbit) {
				this.targetVel.x = -this.targetVel.x;
			}

			if (cutiePos.y > 0) {
				this.runTime = Math.random() * Bunny.runK + Bunny.runB;
				this.jumping = false;
				cutiePos.y = 0;
				this.checkTex();

				if (Tutorial.active && this.position.x > 500) {
					this.scale.x = -1;
					this.speed = -this.speed;
				} else {
					this.scale.x = 1;
					this.speed = Math.abs(this.speed);
				}
			}
			return;
		}

		//running state
		this.runTime -= delta;
		if (this.runTime < 0 && !this.zombie) { // 3 frames for run, rest for jump
			this.jumping = true;
			this.jumpVel = -(Math.random() * Bunny.jumpK + Bunny.jumpB);
			this.cutie.position.y = this.jumpVel;
			this.checkTex();
		}
	}
}